// src/hooks/useModuleAvailability.js
// Answers "is module X / connector source Y available on this installation?" from the backend
// egress catalog (GET /config/features → `modules` and `connectorSources`, see
// backend/Configuration/EgressCatalog.cs). The backend decides; the SPA only reads booleans.
//
// A missing map means "available": an older backend that does not send the maps, and the test
// files that mock FeatureFlagsContext without useDeploymentProfile/useFeatureFlagsLoaded, keep
// seeing every module. Only an explicit `false` hides something.
import * as FeatureFlags from "../contexts/FeatureFlagsContext";

export function useModuleAvailability() {
  // Both hooks are always called (or always skipped) for a given module shape, so hook order is
  // stable across renders.
  const dp = typeof FeatureFlags.useDeploymentProfile === "function" ? FeatureFlags.useDeploymentProfile() : null;
  const loaded = typeof FeatureFlags.useFeatureFlagsLoaded === "function" ? FeatureFlags.useFeatureFlagsLoaded() : true;
  const modules = dp?.modules ?? null;
  const sources = dp?.connectorSources ?? null;
  return {
    loaded,
    isModuleAvailable: (id) => !modules || modules[id] !== false,
    isSourceAvailable: (key) => !sources || sources[key] !== false,
  };
}

export default useModuleAvailability;
